import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import _ from "lodash"
import bowser from "bowser"

import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"
import HiddenReadableText from "@cirrus/legacy/app-components/readspeaker/hiddenReadableText/index.jsx"

import styles from "./drop-down.less"

export default class StatelessDropDown extends C {
  constructor(props) {
    super(props)
    this.placeholderId = "dropdownplaceholder"

    this._isIE = bowser.check({ msie: "11", msedge: "12" }, true)
  }

  static propTypes = {
    className: PropTypes.string,
    collection: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    isNotValid: PropTypes.bool,
    dataQa: PropTypes.string,
    type: PropTypes.string,
  }

  onChange(e) {
    var value = e.target.value
    if (this.props.onChange) {
      this.props.onChange(e, value)
    }
  }

  getClass() {
    return classNames(
      styles.easCombobox,
      this.props.className,
      "rs_preserve",
      {
        [styles.disabled]: this.props.disabled,
      },
      this.props.isNotValid ? styles.notValid : "",
    )
  }

  onFocus() {
    $(this.combobox).toggleClass(styles.active)
  }

  onBlur() {
    $(this.combobox).removeClass(styles.active)
  }

  get placeholder() {
    let placeholder = this.props.placeholder
    let placeholders = {
      string: () => (
        <option value={this.placeholderId} disabled>
          {placeholder}
        </option>
      ),
      object: () => (
        <option value={placeholder.id || this.placeholderId} disabled>
          {placeholder.title}
        </option>
      ),
    }
    let getPlaceholder = placeholders[typeof placeholder]

    return getPlaceholder && getPlaceholder()
  }

  get options() {
    let collection = this.props.collection
    return collection.map((item) => (
      <option
        key={item.id}
        value={item.id}
        disabled={item.disabled}
        hidden={!this._isIE && item.hidden}>
        {item.title}
      </option>
    ))
  }

  get selectedOption() {
    let collection = this.props.collection
    return _.find(collection, (item) => item.id === this.value)
  }

  get value() {
    let value = this.props.value
    let collection = this.props.collection

    if (value == null || !_.find(collection, (item) => item.id == value)) {
      value = this.placeholderId
    }
    return value
  }

  render() {
    return (
      <div className={this.getClass()} ref={(combobox) => (this.combobox = combobox)}>
        <HiddenReadableText text={this.selectedOption && this.selectedOption.title} />
        <select
          disabled={this.props.disabled}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          className={this.props.type == "fit-content" ? styles.fitContent : null}
          onChange={this.onChange.bind(this)}
          value={this.value}
          data-qa={this.props.dataQa}>
          {this.placeholder}
          {this.options}
        </select>
      </div>
    )
  }
}
